import React from 'react';

const BottomBar = () => {
  return (
    <div style={{
      height: '40px',
      background: '#161b22',
      color: '#64748b',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 20px',
      borderTop: '1px solid #2d3748',
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      fontSize: '0.8rem',
      zIndex: 1002
    }}>
      <div>
        © 2026 <span style={{ color: '#94a3b8' }}>e-screen cloud</span>
      </div>
      <div>
        Powered by <span style={{ color: 'white', fontWeight: 'bold' }}>EcoPell</span>
      </div>
    </div>
  );
};

export default BottomBar;